const ActionError = function(type, message, nextStepAction, samlRequest, relayState) {
  this.type = type
  this.message = message
  this.nextStep = nextStepAction
  this.samlRequest = samlRequest
  this.relayState = relayState
}

ActionError.prototype = Object.create(Error.prototype)
ActionError.prototype.constructor = ActionError

export default ActionError


/** WEBPACK FOOTER **
 ** ./components/utils/action-error.js
 **/